import script from "./Top50Modal.vue?vue&type=script&setup=true&lang=js"
export * from "./Top50Modal.vue?vue&type=script&setup=true&lang=js"

import "./Top50Modal.vue?vue&type=style&index=0&id=6f278040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f278040"]])

export default __exports__